import PerformanceReviewThumb from 'assets/icons/ReportThumbs/performance_review.png';
import PurchasePatternThumb from 'assets/icons/ReportThumbs/purchase_pattern.png';
import RepeatVisitsThumb from 'assets/icons/ReportThumbs/repeat_visits.png';
import TopMetroThumb from 'assets/icons/ReportThumbs/top_metro.png';
import TransactionVolumeThumb from 'assets/icons/ReportThumbs/transaction_volume.png';
import TransactionsThumb from 'assets/icons/ReportThumbs/transactions.png';
import DemographicsAgeThumb from 'assets/icons/ReportThumbs/demographics_age.png';
import PerformanceYearOverYear from 'assets/icons/ReportThumbs/performance_year_over_year.png';

export default [
  {
    key: 'performanceOverview',
    text: 'Performance Overview',
    image: PerformanceReviewThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'performanceOverviewBySegment',
    text: 'Performance Overview By Segment',
    image: PerformanceReviewThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'repeatVisits',
    text: 'Repeat Visits',
    image: RepeatVisitsThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'repeatVisitsBySegment',
    text: 'Repeat Visits By Segment',
    image: RepeatVisitsThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'transactions',
    text: 'Transactions',
    image: TransactionsThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'transactionsBySegment',
    text: 'Transactions By Segment',
    image: TransactionsThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'onlineOfflineTransactions',
    text: 'Transactions: Online/In-Store',
    image: TransactionsThumb,
    meta: { thirdPartyReport: false, showForOnlineOnly: true, type: 'Dosh' },
  },
  {
    key: 'transactionVolume',
    text: 'Transaction Volume',
    value: 'transactionVolume',
    image: TransactionVolumeThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'topMetroTransactions',
    text: 'Top Metro: Transactions',
    value: 'top-metro-transactions',
    image: TopMetroThumb,
    meta: { thirdPartyReport: false, showForOnline: false, type: 'Dosh' },
  },
  {
    key: 'topMetroAOV',
    text: 'Top Metro: Aov',
    image: TopMetroThumb,
    meta: { thirdPartyReport: false, showForOnline: false, type: 'Dosh' },
  },
  {
    key: 'topMetroSales',
    text: 'Top Metro: Sales',
    image: TopMetroThumb,
    meta: { thirdPartyReport: false, showForOnline: false, type: 'Dosh' },
  },
  {
    key: 'subscriberPurchasePatterns',
    text: 'Subscriber Purchase Patterns',
    image: PurchasePatternThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'subscriberPurchasePatternsBySegment',
    text: 'Subscriber Purchase Patterns By Segment',
    image: PurchasePatternThumb,
    meta: { thirdPartyReport: false, showForOnline: true, type: 'Dosh' },
  },
  {
    key: 'shopperDemographics',
    text: 'Shopper Demographics',
    image: DemographicsAgeThumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Dosh',
      border: true,
    },
  },
  {
    key: 'salesYearOverYear',
    text: 'Sales Year Over Year',
    image: PerformanceYearOverYear,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Dosh',
      border: true,
    },
  },
  {
    key: 'transactionsYearOverYear',
    text: 'Transactions Year Over Year',
    image: PerformanceYearOverYear,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Dosh',
      border: true,
    },
  },
  {
    key: 'transactionsYearOverYearByVenueType',
    text: 'Transactions Year Over Year by Venue Type',
    image: PerformanceYearOverYear,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Dosh',
      border: true,
    },
  },
  {
    key: 'salesYearOverYearByVenueType',
    text: 'Sales Year Over Year by Venue Type',
    image: PerformanceYearOverYear,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Dosh',
      border: true,
    },
  },
];
